import { DYNAMIC_PAGE_REDIRECT_PATHS } from '../../../constants/externalUrls'
import { REDIRECT_URL } from '../../../constants/navigation'
import { isUrlPatternMatching, toLower } from '../../../util/string.helpers'
import { EAGLES_REF, MODA_REDEMPTION_URL_MATCH } from '../constants/app'

const truthbrushUrl = () => {
  return `${REDIRECT_URL}/${DYNAMIC_PAGE_REDIRECT_PATHS.TRUTHBRUSH}`
}

const zDentalUrl = () => {
  return `${REDIRECT_URL}/${DYNAMIC_PAGE_REDIRECT_PATHS.Z_DENTAL}`
}

const myLabsUrl = () => {
  return `${REDIRECT_URL}/${DYNAMIC_PAGE_REDIRECT_PATHS.MYLABS}`
}

const REDEMPTION_URL_BUILDERS = [
  {
    pattern: MODA_REDEMPTION_URL_MATCH.TRUTHBRUSH,
    buildUrl: () => truthbrushUrl()
  },
  {
    pattern: MODA_REDEMPTION_URL_MATCH.Z_DENTAL,
    buildUrl: () => zDentalUrl()
  },
  {
    pattern: MODA_REDEMPTION_URL_MATCH.MYLABS,
    buildUrl: () => myLabsUrl()
  },
  {
    pattern: MODA_REDEMPTION_URL_MATCH.IREDEEM,
    buildUrl: ({ authId }) => iRedeemEarnUrl(authId)
  }
]

const buildRedemptionUrl = (url, authId) => {
  const redemptionUrlBuilder = REDEMPTION_URL_BUILDERS.find(({ pattern }) => {
    return isUrlPatternMatching(url, pattern)
  })

  if (redemptionUrlBuilder) {
    return redemptionUrlBuilder.buildUrl({ authId })
  }

  return url
}

const isWelcomeRefMatching = (currentRef) => {
  return EAGLES_REF.some((ref) => toLower(ref) === toLower(currentRef))
}

const IREDEEEM_BASE_URL = 'https://order.iredeemhealth.com/site/earnwell'

const iRedeemEarnUrl = (authId) => {
  return `${IREDEEEM_BASE_URL}?member_id=${authId}`
}

export {
  buildRedemptionUrl,
  IREDEEEM_BASE_URL,
  iRedeemEarnUrl,
  isWelcomeRefMatching,
  myLabsUrl,
  truthbrushUrl,
  zDentalUrl
}
